module.exports = __webpack_public_path__ + "img/icon_my.0067f7b.webp";